import { InputAdornment, Stack, TextField, Typography } from '@mui/material';
import type { UnitConverter } from '/@/core/units';
import { _ } from '/@/locale';

interface PlantedAreaInputProps {
    value: number | undefined;
    onChange: (value: number | undefined) => void;
    units: UnitConverter;
    error?: string;
}

const PlantedAreaInput = ({ value, onChange, units, error }: PlantedAreaInputProps) => {
    const handleChange = (inputValue: string) => {
        if (!inputValue) {
            onChange(undefined);
            return;
        }
        onChange(units.fromArea(inputValue));
    };

    return (
        <Stack spacing={0.5} sx={{ width: '100%' }}>
            <Typography variant='subtitle1' color='primary' fontWeight='bold'>
                {_('Ha sembradas')}
            </Typography>
            <TextField
                placeholder={_('Indicar las ha sembradas')}
                value={value ? units.toArea(value, 2).value || '' : ''}
                onChange={(e) => handleChange(e.target.value)}
                fullWidth
                type='number'
                error={!!error}
                helperText={error}
                inputProps={{ 'data-testid': 'field-monitoring-creation-dialog-planted-area-input' }}
                InputProps={{
                    endAdornment: <InputAdornment position='end'>{units.getUnit('area')}</InputAdornment>,
                }}
            />
        </Stack>
    );
};

export default PlantedAreaInput;
